import React, { useEffect } from 'react';
import { find, get, isEmpty, reduce } from 'lodash';

export const fieldInitialValues = fields =>
  reduce(fields, (acc, field) => ({ ...acc, [field.id]: get(field, 'initialValue', undefined) }), {});

export const getFieldValuesFromObject = (fields, values) =>
  reduce(
    fields,
    (acc, field) => ({ ...acc, [field.id]: get(values, [field.id], get(field, 'initialValue', undefined)) }),
    {},
  );

const mapQueryToFilterItems = (query, listFilters) => {
  const options = {};
  if (query && !isEmpty(query)) {
    Object.keys(query).forEach(type => {
      const filters = find(listFilters, { type });
      if (filters) {
        const filterItems = get(filters, 'items', []).find(
          filterItem => Number(get(filterItem, 'id')) === Number(get(query, type)),
        );
        options[type] = {
          value: get(filterItems, 'id'),
          label: get(filterItems, 'name'),
          slug: get(filterItems, 'slug'),
        };
      }
    });
  }
  return options;
};

export function useFormFilters(formFields, queryValues, listFilters) {
  const fieldsInitialValues = fieldInitialValues(formFields);
  const [formValues, setFormValues] = React.useState(fieldsInitialValues);

  useEffect(() => {
    const queryFilterValues = mapQueryToFilterItems(queryValues, listFilters);
    const query = get(queryValues, 'query');
    if (query) {
      queryFilterValues.query = query;
    }
    const onlyFormValues = getFieldValuesFromObject(formFields, queryFilterValues);
    setFormValues(onlyFormValues);
  }, [formFields, queryValues, listFilters]);

  return [formValues, fieldsInitialValues];
}

export const getFlatFormValues = values => {
  const query = {};
  const keys = Object.keys(values);

  keys.forEach(key => {
    if (values[key] && typeof values[key] === 'string') {
      query[key] = values[key];
    }
    if (values[key] && values[key].value) {
      query[key] = values[key].value;
    }
  });
  return query;
};

export const getQueryStringFromObject = object =>
  Object.keys(object || {})
    .map(key => `${key}=${get(object, key)}`)
    .join('&');
